export default __webpack_public_path__ + "static/media/white-logo.09b37b05.svg";